import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-close-mobile]',
  templateUrl: './close-mobile.component.html',
  styleUrls: ['./close-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
